export interface IMusic {
  id: 1;
  sort: 1;
  chord_1: string;
  chord_2: string;
  chord_3: string;
  chord_4: string;
  chord_5: string;
  chord_6: string;
  chord_7: string;
  chord_8: string;
  chord_9: string;
  chord_10: string;
  chord_11: string;
  chord_12: string;
  chord_13: string;
  chord_14: string;
  chord_15: string;
  chord_16: string;
  lyrics_1: string;
  lyrics_2: string;
  lyrics_3: string;
  lyrics_4: string;
  created_at: string;
}

export interface INoteData {
  info: {
    id: number;
    title: string;
    category: string;
    sub_category: string;
    year: string;
    month: string;
    time: string;
    beat: string;
    singer: string;
    original_key: string;
    notice?: string | null;
    created_at: string;
    sec: string;
  } | null;
  musics: IMusic[];
  preview?: { rows: number; total: number }; // 맛보기: 앞부분만 받은 악보
  free?: boolean; // 이번 주 무료 곡
  personal?: boolean; // 내 악보(회원이 만든 비공개 악보) — 연주목록·수정 요청·강좌·점수 기록 없음
}

export const initialNoteData: INoteData = {
  info: null,
  musics: [],
};
